(function() {
  'use strict';

  angular
    .module('admin.users.details.favorites', [])
    .controller('FavoritesAdminCtrl', FavoritesAdminCtrl);

  /** @ngInject */
  function FavoritesAdminCtrl($scope, $stateParams, UsersService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;

    vm.sortType = '';
    vm.sortReverse = false;

    load();

    function load() {
      UsersService.listFavotireChannels($stateParams.parentId, vm.sortType).then(success);

      function success(result){
        vm.items = result.results;
      }
    }
    
    vm.sort = function(type){
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + '-asc';
      } else {
        vm.sortType = type + '-desc';
      }
      load();
    };
  }

})();
